import { useSuspenseQuery } from '@tanstack/react-query';
import { productSummaryQueries } from '../queries/productSummaryQueries';
import { fetchProductSummaryLastUpdateTime } from './../../api/productSummaryApi';

export const useProductSummaryLastUpdate = () => {
  return useSuspenseQuery({
    queryKey: productSummaryQueries.lastUpdateTimestamp(),
    queryFn: () => {
      return fetchProductSummaryLastUpdateTime();
    },
  });
};
